export const categoriasNombres = {
  "05": "Higiene ",
  "01": "Capilar",
  "02": "Perfumería",
  "06": "Maquillaje",
  "04": "Facial",
};
